import { IChat } from '../../../global';
import getChatName from './getChatName';

export default (chatA: IChat, chatB: IChat) => {
  const nameA = getChatName(chatA);
  const nameB = getChatName(chatB);

  return nameA > nameB ? 1 : -1;
};
